var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('page-header',{attrs:{"title":"Create New Consolidation","breadcrumb":"Bookings & Shipments > Load Consolidation > Create New"}}),_c('div',{staticClass:"px-3 py-4 bg-white mt-5"},[_c('TabIndicator',{attrs:{"index":"3"}}),_c('keep-alive',[_c(_vm.currentPage,{tag:"components"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }